import * as accountDropdown from './account-dropdown';
import * as addOns from './add-ons';
import * as anyBookFunnel from './anyBookFunnel';
import * as autoCharge from './auto-charge';
import * as blackFriday from './black-friday';
import * as chooseCabinBase from './choose-cabin';
import * as chooseCabin30 from './choose-cabin-30';
import * as common from './common';
import * as cordialTags from './cordialTags';
import * as ECommercePromotions from './ecommerce-promotions';
import * as fareClass from './fareClass';
import * as mobileBookingFlow from './mobile-booking-flow';
import * as promoBanners from './promo-banners';
import * as shared from './shared';
import * as summary from './summary';
import * as trackingUtils from './utils';
import * as voyageDetails from './voyageDetails';
import * as voyagesFilter from './voyagesFilter';

const chooseCabin = {
  // Merging as events are connected to the same page
  ...chooseCabinBase,
  ...chooseCabin30,
};

export {
  accountDropdown,
  addOns,
  anyBookFunnel,
  autoCharge,
  blackFriday,
  chooseCabin,
  common,
  cordialTags,
  ECommercePromotions,
  fareClass,
  mobileBookingFlow,
  promoBanners,
  shared,
  summary,
  trackingUtils,
  voyageDetails,
  voyagesFilter,
};
